export default __webpack_public_path__ + "static/media/icon-cliniter.7b387682.svg";